<div class="payment payment-options">
  <header class="modal__header">
    <h2>{{ "payment.receipt.label.your_order" | translate }}</h2>
    <a class="button button--transparent modal__button--close" (click)="closeModal()"><i class="icon icon-ui-close--sm"></i></a>
  </header>
  <div class="modal__content">
    <form class="form">
      <!-- Total cost, only show when receipt is set -->
      <div class="form-block form-block__border" *ngIf="!isRetry">
        <air-payment-total></air-payment-total>
      </div>

      <div class="form-block form-block__border">
        <!-- Sticky CTA -->
        <div class="form-group payment__cta">
          <h3 class="h3--sm payment-options__header" *ngIf="!isRetry && payment && payment.receipt">
            {{ ("payment.methods.label.total_header" | translate).format([payment.receipt.total.price | currency]) }}
          </h3>

          <div class="payment-methods" [@animationStepSwitcher]="animationState">
            <div class="payment-methods-block">
              <h5 class="h5--sm">{{ "payment.methods.label.select_option" | translate }}</h5>
              <ul class="payment-methods-list">
                <li
                  *ngFor="let method of paymentMethods"
                  class="payment-methods-list__item"
                  [ngClass]="{ selected: method === payment?.paymentMethod }"
                  (click)="onSelectMethod(method)"
                >
                  <img *ngIf="method.logo" [src]="method.logo.cropUrl" [alt]="method.title" />
                  <h5>{{ method.title }}</h5>
                </li>
              </ul>
            </div>

            <div class="payment-methods-block" *ngIf="payment?.paymentMethod?.paymentIssuers?.length" @animationShowIssuers>
              <h5 class="h5--sm">{{ "payment.methods.label.select_bank" | translate }}</h5>
              <ul class="payment-methods-list">
                <li
                  *ngFor="let issuer of payment?.paymentMethod?.paymentIssuers"
                  class="payment-methods-list__item"
                  [ngClass]="{ selected: issuer === payment?.paymentIssuer }"
                  (click)="onSelectIssuer(issuer)"
                >
                  <img *ngIf="issuer.logo" [src]="issuer.logo.cropUrl" [alt]="issuer.title" />
                  <h5>{{ issuer.title }}</h5>
                </li>
              </ul>
            </div>
          </div>

          <div class="button__group button__group--stretch">
            <a type="button" class="button button--tertiary" (click)="onBackClick($event)">
              <i class="icon icon--sm icon-ui-arrow--left"></i>
              <span>{{ "general.label.back" | translate }}</span>
            </a>

            <a
              class="button button--cta"
              [class.button--disabled]="!canContinue ? true : null"
              [airButtonLoading]="isSubmitting"
              (click)="onNextClick($event)"
            >
              <span>{{ "general.label.next" | translate }}</span>
            </a>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
